/**
 * Formats a date string into "MMM DD" format (e.g., "Jan 20").
 * 
 * @param dateString - The date string to format.
 * @returns The formatted date in "MMM DD" format.
 */
export const formatDay = (dateString: string): string => {
    if (!dateString) {
        throw new Error("A valid date string must be provided.");
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        throw new Error("Invalid date string.");
    }

    const options: Intl.DateTimeFormatOptions = {
        month: "short",
        day: "numeric",
        timeZone: "Canada/Eastern"
    };

    return date.toLocaleDateString("en-US", options);
};

/**
 * Formats a date string into "d/m/y" format (e.g., "o1/01/2000").
 * 
 * @param dateString - The date string to format.
 * @returns The formatted date in "d/m/y" format.
 */
export const formatDate = (dateString: string): string => {
    if (!dateString) {
        throw new Error("A valid date string must be provided.");
    }

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
        throw new Error("Invalid date string.");
    }

    return date.toLocaleDateString();
}
